import * as Web3Utils from "web3-utils";
export function shortenAddress(pAddress, pDigits = 4) {
    if (!isAddress(pAddress)) {
        throw Error(`Invalid 'address' parameter '${pAddress}'.`);
    }
    return `${pAddress.substring(0, pDigits + 2)}...${pAddress.substring(
        42 - pDigits
    )}`;
}

export function isAddress(pValue) {
    try {
        return Web3Utils.isAddress(pValue.toLowerCase());
    } catch {
        return false;
    }
}

export function showError(pValue) {
    const appEl = document.querySelector(".App");
    const alertEl = document.createElement("div");
    alertEl.classList.add("alert");
    const alertChildEl = document.createElement("div");
    alertChildEl.classList.add("alert-container");
    alertChildEl.textContent = pValue;
    alertEl.appendChild(alertChildEl);
    appEl.appendChild(alertEl);
    setTimeout(() => {
        appEl.removeChild(alertEl);
    }, 3000);
}

export const poolTogetherDrawDates = [
    '15 May 2020 12:00 PDT',
    '22 May 2020 12:00 PDT',
    '29 May 2020 12:00 PDT',
    '05 Jun 2020 12:00 PDT',
    '12 Jun 2020 12:00 PDT',
    '19 Jun 2020 12:00 PDT',
    '26 Jun 2020 12:00 PDT',
    '03 Jul 2020 12:00 PDT',
    '10 Jul 2020 12:00 PDT',
    '17 Jul 2020 12:00 PDT',
    '24 Jul 2020 12:00 PDT',
    '31 Jul 2020 12:00 PDT',
    '07 Aug 2020 12:00 PDT',
    '14 Aug 2020 12:00 PDT',
    '21 Aug 2020 12:00 PDT',
    '28 Aug 2020 12:00 PDT',
    '04 Sep 2020 12:00 PDT',
    '11 Sep 2020 12:00 PDT',
    '18 Sep 2020 12:00 PDT',
    '25 Sep 2020 12:00 PDT',
    '02 Oct 2020 12:00 PDT',
    '09 Oct 2020 12:00 PDT',
    '16 Oct 2020 12:00 PDT',
    '23 Oct 2020 12:00 PDT',
    '30 Oct 2020 12:00 PDT',
    '06 Nov 2020 12:00 PDT',
    '13 Nov 2020 12:00 PDT',
    '20 Nov 2020 12:00 PDT',
    '27 Nov 2020 12:00 PDT',
    '04 Dec 2020 12:00 PDT',
    '11 Dec 2020 12:00 PDT',
    '18 Dec 2020 12:00 PDT',
    '25 Dec 2020 12:00 PDT',
    '01 Jan 2021 12:00 PDT',
    '08 Jan 2021 12:00 PDT',
    '15 Jan 2021 12:00 PDT',
    '22 Jan 2021 12:00 PDT',
    '29 Jan 2021 12:00 PDT',
    '05 Feb 2021 12:00 PDT',
    '12 Feb 2021 12:00 PDT',
    '19 Feb 2021 12:00 PDT',
    '26 Feb 2021 12:00 PDT',
    '05 Mar 2021 12:00 PDT',
    '12 Mar 2021 12:00 PDT',
    '19 Mar 2021 12:00 PDT',
    '26 Mar 2021 12:00 PDT',
    '02 Apr 2021 12:00 PDT',
    '09 Apr 2021 12:00 PDT',
    '16 Apr 2021 12:00 PDT',
    '23 Apr 2021 12:00 PDT',
    '30 Apr 2021 12:00 PDT',
    '07 May 2021 12:00 PDT',
    '14 May 2021 12:00 PDT',
    '21 May 2021 12:00 PDT',
    '28 May 2021 12:00 PDT',
    '04 Jun 2021 12:00 PDT',
    '11 Jun 2021 12:00 PDT',
    '18 Jun 2021 12:00 PDT',
    '25 Jun 2021 12:00 PDT',
    '02 Jul 2021 12:00 PDT',
    '09 Jul 2021 12:00 PDT',
    '16 Jul 2021 12:00 PDT',
    '23 Jul 2021 12:00 PDT',
    '30 Jul 2021 12:00 PDT',
    '06 Aug 2021 12:00 PDT',
    '13 Aug 2021 12:00 PDT',
    '20 Aug 2021 12:00 PDT',
    '27 Aug 2021 12:00 PDT',
    '03 Sep 2021 12:00 PDT',
    '10 Sep 2021 12:00 PDT',
    '17 Sep 2021 12:00 PDT',
    '24 Sep 2021 12:00 PDT',
    '01 Oct 2021 12:00 PDT',
    '08 Oct 2021 12:00 PDT',
    '15 Oct 2021 12:00 PDT',
    '22 Oct 2021 12:00 PDT',
    '29 Oct 2021 12:00 PDT',
    '05 Nov 2021 12:00 PDT',
    '12 Nov 2021 12:00 PDT',
    '19 Nov 2021 12:00 PDT',
    '26 Nov 2021 12:00 PDT',
    '03 Dec 2021 12:00 PDT',
    '10 Dec 2021 12:00 PDT',
    '17 Dec 2021 12:00 PDT',
    '24 Dec 2021 12:00 PDT',
    '31 Dec 2021 12:00 PDT',
    '07 Jan 2022 12:00 PDT',
    '14 Jan 2022 12:00 PDT',
    '21 Jan 2022 12:00 PDT',
    '28 Jan 2022 12:00 PDT',
    '04 Feb 2022 12:00 PDT',
    '11 Feb 2022 12:00 PDT',
    '18 Feb 2022 12:00 PDT',
    '25 Feb 2022 12:00 PDT',
    '04 Mar 2022 12:00 PDT',
    '11 Mar 2022 12:00 PDT',
    '18 Mar 2022 12:00 PDT',
    '25 Mar 2022 12:00 PDT',
    '01 Apr 2022 12:00 PDT',
    '08 Apr 2022 12:00 PDT',
    '15 Apr 2022 12:00 PDT',
    '22 Apr 2022 12:00 PDT',
    '29 Apr 2022 12:00 PDT',
    '06 May 2022 12:00 PDT',
    '13 May 2022 12:00 PDT',
    '20 May 2022 12:00 PDT',
    '27 May 2022 12:00 PDT',
    '03 Jun 2022 12:00 PDT',
    '10 Jun 2022 12:00 PDT',
    '17 Jun 2022 12:00 PDT',
    '24 Jun 2022 12:00 PDT',
    '01 Jul 2022 12:00 PDT',
    '08 Jul 2022 12:00 PDT',
    '15 Jul 2022 12:00 PDT',
    '22 Jul 2022 12:00 PDT',
    '29 Jul 2022 12:00 PDT',
    '05 Aug 2022 12:00 PDT',
    '12 Aug 2022 12:00 PDT',
    '19 Aug 2022 12:00 PDT',
    '26 Aug 2022 12:00 PDT',
    '02 Sep 2022 12:00 PDT',
    '09 Sep 2022 12:00 PDT',
    '16 Sep 2022 12:00 PDT',
    '23 Sep 2022 12:00 PDT',
    '30 Sep 2022 12:00 PDT',
    '07 Oct 2022 12:00 PDT',
    '14 Oct 2022 12:00 PDT',
    '21 Oct 2022 12:00 PDT',
    '28 Oct 2022 12:00 PDT',
    '04 Nov 2022 12:00 PDT',
    '11 Nov 2022 12:00 PDT',
    '18 Nov 2022 12:00 PDT',
    '25 Nov 2022 12:00 PDT',
    '02 Dec 2022 12:00 PDT',
    '09 Dec 2022 12:00 PDT',
    '16 Dec 2022 12:00 PDT',
    '23 Dec 2022 12:00 PDT',
    '30 Dec 2022 12:00 PDT',
    '06 Jan 2023 12:00 PDT',
    '13 Jan 2023 12:00 PDT',
    '20 Jan 2023 12:00 PDT',
    '27 Jan 2023 12:00 PDT',
    '03 Feb 2023 12:00 PDT',
    '10 Feb 2023 12:00 PDT',
    '17 Feb 2023 12:00 PDT',
    '24 Feb 2023 12:00 PDT',
    '03 Mar 2023 12:00 PDT',
    '10 Mar 2023 12:00 PDT',
    '17 Mar 2023 12:00 PDT',
    '24 Mar 2023 12:00 PDT',
    '31 Mar 2023 12:00 PDT',
    '07 Apr 2023 12:00 PDT',
    '14 Apr 2023 12:00 PDT',
    '21 Apr 2023 12:00 PDT',
    '28 Apr 2023 12:00 PDT',
    '05 May 2023 12:00 PDT',
    '12 May 2023 12:00 PDT',
    '19 May 2023 12:00 PDT',
    '26 May 2023 12:00 PDT',
    '02 Jun 2023 12:00 PDT',
    '09 Jun 2023 12:00 PDT',
    '16 Jun 2023 12:00 PDT',
    '23 Jun 2023 12:00 PDT',
    '30 Jun 2023 12:00 PDT',
    '07 Jul 2023 12:00 PDT',
    '14 Jul 2023 12:00 PDT',
    '21 Jul 2023 12:00 PDT',
    '28 Jul 2023 12:00 PDT',
    '04 Aug 2023 12:00 PDT',
    '11 Aug 2023 12:00 PDT',
    '18 Aug 2023 12:00 PDT',
    '25 Aug 2023 12:00 PDT',
    '01 Sep 2023 12:00 PDT',
    '08 Sep 2023 12:00 PDT',
    '15 Sep 2023 12:00 PDT',
    '22 Sep 2023 12:00 PDT',
    '29 Sep 2023 12:00 PDT',
    '06 Oct 2023 12:00 PDT',
    '13 Oct 2023 12:00 PDT',
    '20 Oct 2023 12:00 PDT',
    '27 Oct 2023 12:00 PDT',
    '03 Nov 2023 12:00 PDT',
    '10 Nov 2023 12:00 PDT',
    '17 Nov 2023 12:00 PDT',
    '24 Nov 2023 12:00 PDT',
    '01 Dec 2023 12:00 PDT',
    '08 Dec 2023 12:00 PDT',
    '15 Dec 2023 12:00 PDT',
    '22 Dec 2023 12:00 PDT',
    '29 Dec 2023 12:00 PDT',
    '05 Jan 2024 12:00 PDT',
    '12 Jan 2024 12:00 PDT',
    '19 Jan 2024 12:00 PDT',
    '26 Jan 2024 12:00 PDT',
    '02 Feb 2024 12:00 PDT',
    '09 Feb 2024 12:00 PDT',
    '16 Feb 2024 12:00 PDT',
    '23 Feb 2024 12:00 PDT',
    '01 Mar 2024 12:00 PDT',
    '08 Mar 2024 12:00 PDT',
    '15 Mar 2024 12:00 PDT',
    '22 Mar 2024 12:00 PDT',
    '29 Mar 2024 12:00 PDT',
    '05 Apr 2024 12:00 PDT',
    '12 Apr 2024 12:00 PDT',
    '19 Apr 2024 12:00 PDT',
    '26 Apr 2024 12:00 PDT',
    '03 May 2024 12:00 PDT',
    '10 May 2024 12:00 PDT',
    '17 May 2024 12:00 PDT',
    '24 May 2024 12:00 PDT',
    '31 May 2024 12:00 PDT',
    '07 Jun 2024 12:00 PDT',
    '14 Jun 2024 12:00 PDT',
    '21 Jun 2024 12:00 PDT',
    '28 Jun 2024 12:00 PDT',
    '05 Jul 2024 12:00 PDT',
    '12 Jul 2024 12:00 PDT',
    '19 Jul 2024 12:00 PDT',
    '26 Jul 2024 12:00 PDT',
    '02 Aug 2024 12:00 PDT',
    '09 Aug 2024 12:00 PDT',
    '16 Aug 2024 12:00 PDT',
    '23 Aug 2024 12:00 PDT',
    '30 Aug 2024 12:00 PDT',
    '06 Sep 2024 12:00 PDT',
    '13 Sep 2024 12:00 PDT',
    '20 Sep 2024 12:00 PDT',
    '27 Sep 2024 12:00 PDT',
    '04 Oct 2024 12:00 PDT',
    '11 Oct 2024 12:00 PDT',
    '18 Oct 2024 12:00 PDT',
    '25 Oct 2024 12:00 PDT',
    '01 Nov 2024 12:00 PDT',
    '08 Nov 2024 12:00 PDT',
    '15 Nov 2024 12:00 PDT',
    '22 Nov 2024 12:00 PDT',
    '29 Nov 2024 12:00 PDT',
    '06 Dec 2024 12:00 PDT',
    '13 Dec 2024 12:00 PDT',
    '20 Dec 2024 12:00 PDT',
    '27 Dec 2024 12:00 PDT',
    '03 Jan 2025 12:00 PDT',
    '10 Jan 2025 12:00 PDT',
    '17 Jan 2025 12:00 PDT',
    '24 Jan 2025 12:00 PDT',
    '31 Jan 2025 12:00 PDT',
    '07 Feb 2025 12:00 PDT',
    '14 Feb 2025 12:00 PDT',
    '21 Feb 2025 12:00 PDT',
    '28 Feb 2025 12:00 PDT',
    '07 Mar 2025 12:00 PDT',
    '14 Mar 2025 12:00 PDT',
    '21 Mar 2025 12:00 PDT',
    '28 Mar 2025 12:00 PDT',
    '04 Apr 2025 12:00 PDT',
    '11 Apr 2025 12:00 PDT',
    '18 Apr 2025 12:00 PDT',
    '25 Apr 2025 12:00 PDT',
    '02 May 2025 12:00 PDT',
    '09 May 2025 12:00 PDT',
    '16 May 2025 12:00 PDT',
    '23 May 2025 12:00 PDT',
    '30 May 2025 12:00 PDT',
    '06 Jun 2025 12:00 PDT',
    '13 Jun 2025 12:00 PDT',
    '20 Jun 2025 12:00 PDT',
    '27 Jun 2025 12:00 PDT',
    '04 Jul 2025 12:00 PDT',
    '11 Jul 2025 12:00 PDT',
    '18 Jul 2025 12:00 PDT',
    '25 Jul 2025 12:00 PDT',
    '01 Aug 2025 12:00 PDT',
    '08 Aug 2025 12:00 PDT',
    '15 Aug 2025 12:00 PDT',
    '22 Aug 2025 12:00 PDT',
    '29 Aug 2025 12:00 PDT',
    '05 Sep 2025 12:00 PDT',
    '12 Sep 2025 12:00 PDT',
    '19 Sep 2025 12:00 PDT',
    '26 Sep 2025 12:00 PDT',
    '03 Oct 2025 12:00 PDT',
    '10 Oct 2025 12:00 PDT',
    '17 Oct 2025 12:00 PDT',
    '24 Oct 2025 12:00 PDT',
    '31 Oct 2025 12:00 PDT',
    '07 Nov 2025 12:00 PDT',
    '14 Nov 2025 12:00 PDT',
    '21 Nov 2025 12:00 PDT',
    '28 Nov 2025 12:00 PDT',
    '05 Dec 2025 12:00 PDT',
    '12 Dec 2025 12:00 PDT',
    '19 Dec 2025 12:00 PDT',
    '26 Dec 2025 12:00 PDT',
    '02 Jan 2026 12:00 PDT',
    '09 Jan 2026 12:00 PDT',
    '16 Jan 2026 12:00 PDT',
    '23 Jan 2026 12:00 PDT',
    '30 Jan 2026 12:00 PDT',
    '06 Feb 2026 12:00 PDT',
    '13 Feb 2026 12:00 PDT',
    '20 Feb 2026 12:00 PDT',
    '27 Feb 2026 12:00 PDT',
    '06 Mar 2026 12:00 PDT',
    '13 Mar 2026 12:00 PDT',
    '20 Mar 2026 12:00 PDT',
    '27 Mar 2026 12:00 PDT',
    '03 Apr 2026 12:00 PDT',
    '10 Apr 2026 12:00 PDT',
    '17 Apr 2026 12:00 PDT',
    '24 Apr 2026 12:00 PDT',
    '01 May 2026 12:00 PDT',
    '08 May 2026 12:00 PDT',
    '15 May 2026 12:00 PDT',
    '22 May 2026 12:00 PDT',
    '29 May 2026 12:00 PDT',
    '05 Jun 2026 12:00 PDT',
    '12 Jun 2026 12:00 PDT',
    '19 Jun 2026 12:00 PDT',
    '26 Jun 2026 12:00 PDT',
    '03 Jul 2026 12:00 PDT',
    '10 Jul 2026 12:00 PDT',
    '17 Jul 2026 12:00 PDT',
    '24 Jul 2026 12:00 PDT',
    '31 Jul 2026 12:00 PDT',
    '07 Aug 2026 12:00 PDT',
    '14 Aug 2026 12:00 PDT',
    '21 Aug 2026 12:00 PDT',
    '28 Aug 2026 12:00 PDT',
    '04 Sep 2026 12:00 PDT',
    '11 Sep 2026 12:00 PDT',
    '18 Sep 2026 12:00 PDT',
    '25 Sep 2026 12:00 PDT',
    '02 Oct 2026 12:00 PDT',
    '09 Oct 2026 12:00 PDT',
    '16 Oct 2026 12:00 PDT',
    '23 Oct 2026 12:00 PDT',
    '30 Oct 2026 12:00 PDT',
    '06 Nov 2026 12:00 PDT',
    '13 Nov 2026 12:00 PDT',
    '20 Nov 2026 12:00 PDT',
    '27 Nov 2026 12:00 PDT',
    '04 Dec 2026 12:00 PDT',
    '11 Dec 2026 12:00 PDT',
    '18 Dec 2026 12:00 PDT',
    '25 Dec 2026 12:00 PDT',
    '01 Jan 2027 12:00 PDT',
    '08 Jan 2027 12:00 PDT',
    '15 Jan 2027 12:00 PDT',
    '22 Jan 2027 12:00 PDT',
    '29 Jan 2027 12:00 PDT',
    '05 Feb 2027 12:00 PDT',
    '12 Feb 2027 12:00 PDT',
    '19 Feb 2027 12:00 PDT',
    '26 Feb 2027 12:00 PDT',
    '05 Mar 2027 12:00 PDT',
    '12 Mar 2027 12:00 PDT',
    '19 Mar 2027 12:00 PDT',
    '26 Mar 2027 12:00 PDT',
    '02 Apr 2027 12:00 PDT',
    '09 Apr 2027 12:00 PDT',
    '16 Apr 2027 12:00 PDT',
    '23 Apr 2027 12:00 PDT',
    '30 Apr 2027 12:00 PDT',
    '07 May 2027 12:00 PDT',
    '14 May 2027 12:00 PDT',
    '21 May 2027 12:00 PDT',
    '28 May 2027 12:00 PDT',
    '04 Jun 2027 12:00 PDT',
    '11 Jun 2027 12:00 PDT',
    '18 Jun 2027 12:00 PDT',
    '25 Jun 2027 12:00 PDT',
    '02 Jul 2027 12:00 PDT',
    '09 Jul 2027 12:00 PDT',
    '16 Jul 2027 12:00 PDT',
    '23 Jul 2027 12:00 PDT',
    '30 Jul 2027 12:00 PDT',
    '06 Aug 2027 12:00 PDT',
    '13 Aug 2027 12:00 PDT',
    '20 Aug 2027 12:00 PDT',
    '27 Aug 2027 12:00 PDT',
    '03 Sep 2027 12:00 PDT',
    '10 Sep 2027 12:00 PDT',
    '17 Sep 2027 12:00 PDT',
    '24 Sep 2027 12:00 PDT',
    '01 Oct 2027 12:00 PDT',
    '08 Oct 2027 12:00 PDT',
    '15 Oct 2027 12:00 PDT',
    '22 Oct 2027 12:00 PDT',
    '29 Oct 2027 12:00 PDT',
    '05 Nov 2027 12:00 PDT',
    '12 Nov 2027 12:00 PDT',
    '19 Nov 2027 12:00 PDT',
    '26 Nov 2027 12:00 PDT',
    '03 Dec 2027 12:00 PDT',
    '10 Dec 2027 12:00 PDT',
    '17 Dec 2027 12:00 PDT',
    '24 Dec 2027 12:00 PDT',
    '31 Dec 2027 12:00 PDT',
    '07 Jan 2028 12:00 PDT',
    '14 Jan 2028 12:00 PDT',
    '21 Jan 2028 12:00 PDT',
    '28 Jan 2028 12:00 PDT',
    '04 Feb 2028 12:00 PDT',
    '11 Feb 2028 12:00 PDT',
    '18 Feb 2028 12:00 PDT',
    '25 Feb 2028 12:00 PDT',
    '03 Mar 2028 12:00 PDT',
    '10 Mar 2028 12:00 PDT',
    '17 Mar 2028 12:00 PDT',
    '24 Mar 2028 12:00 PDT',
    '31 Mar 2028 12:00 PDT',
    '07 Apr 2028 12:00 PDT',
    '14 Apr 2028 12:00 PDT',
    '21 Apr 2028 12:00 PDT',
    '28 Apr 2028 12:00 PDT',
    '05 May 2028 12:00 PDT',
    '12 May 2028 12:00 PDT',
    '19 May 2028 12:00 PDT',
    '26 May 2028 12:00 PDT',
    '02 Jun 2028 12:00 PDT',
    '09 Jun 2028 12:00 PDT',
    '16 Jun 2028 12:00 PDT',
    '23 Jun 2028 12:00 PDT',
    '30 Jun 2028 12:00 PDT',
    '07 Jul 2028 12:00 PDT',
    '14 Jul 2028 12:00 PDT',
    '21 Jul 2028 12:00 PDT',
    '28 Jul 2028 12:00 PDT',
    '04 Aug 2028 12:00 PDT',
    '11 Aug 2028 12:00 PDT',
    '18 Aug 2028 12:00 PDT',
    '25 Aug 2028 12:00 PDT',
    '01 Sep 2028 12:00 PDT',
    '08 Sep 2028 12:00 PDT',
    '15 Sep 2028 12:00 PDT',
    '22 Sep 2028 12:00 PDT',
    '29 Sep 2028 12:00 PDT',
    '06 Oct 2028 12:00 PDT',
    '13 Oct 2028 12:00 PDT',
    '20 Oct 2028 12:00 PDT',
    '27 Oct 2028 12:00 PDT',
    '03 Nov 2028 12:00 PDT',
    '10 Nov 2028 12:00 PDT',
    '17 Nov 2028 12:00 PDT',
    '24 Nov 2028 12:00 PDT',
    '01 Dec 2028 12:00 PDT',
    '08 Dec 2028 12:00 PDT',
    '15 Dec 2028 12:00 PDT',
    '22 Dec 2028 12:00 PDT',
    '29 Dec 2028 12:00 PDT',
    '05 Jan 2029 12:00 PDT',
    '12 Jan 2029 12:00 PDT',
    '19 Jan 2029 12:00 PDT',
    '26 Jan 2029 12:00 PDT',
    '02 Feb 2029 12:00 PDT',
    '09 Feb 2029 12:00 PDT',
    '16 Feb 2029 12:00 PDT',
    '23 Feb 2029 12:00 PDT',
    '02 Mar 2029 12:00 PDT',
    '09 Mar 2029 12:00 PDT',
    '16 Mar 2029 12:00 PDT',
    '23 Mar 2029 12:00 PDT',
    '30 Mar 2029 12:00 PDT',
    '06 Apr 2029 12:00 PDT',
    '13 Apr 2029 12:00 PDT',
    '20 Apr 2029 12:00 PDT',
    '27 Apr 2029 12:00 PDT',
    '04 May 2029 12:00 PDT',
    '11 May 2029 12:00 PDT',
    '18 May 2029 12:00 PDT',
    '25 May 2029 12:00 PDT',
    '01 Jun 2029 12:00 PDT',
    '08 Jun 2029 12:00 PDT',
    '15 Jun 2029 12:00 PDT',
    '22 Jun 2029 12:00 PDT',
    '29 Jun 2029 12:00 PDT',
    '06 Jul 2029 12:00 PDT',
    '13 Jul 2029 12:00 PDT',
    '20 Jul 2029 12:00 PDT',
    '27 Jul 2029 12:00 PDT',
    '03 Aug 2029 12:00 PDT',
    '10 Aug 2029 12:00 PDT',
    '17 Aug 2029 12:00 PDT',
    '24 Aug 2029 12:00 PDT',
    '31 Aug 2029 12:00 PDT',
    '07 Sep 2029 12:00 PDT',
    '14 Sep 2029 12:00 PDT',
    '21 Sep 2029 12:00 PDT',
    '28 Sep 2029 12:00 PDT',
    '05 Oct 2029 12:00 PDT',
    '12 Oct 2029 12:00 PDT',
    '19 Oct 2029 12:00 PDT',
    '26 Oct 2029 12:00 PDT',
    '02 Nov 2029 12:00 PDT',
    '09 Nov 2029 12:00 PDT',
    '16 Nov 2029 12:00 PDT',
    '23 Nov 2029 12:00 PDT',
    '30 Nov 2029 12:00 PDT',
    '07 Dec 2029 12:00 PDT',
    '14 Dec 2029 12:00 PDT',
    '21 Dec 2029 12:00 PDT',
    '28 Dec 2029 12:00 PDT',
    '04 Jan 2030 12:00 PDT',
  ];